(function() {
    const apiKey = '40c06716e9ab685459007e4b12b0edb6';
    const redirectPath = '/pages/sorry';
    const allowedCountry = 'US';

    if (window.location.pathname === redirectPath) return;

    // Check if we already know they are blocked
    const sessionStatus = sessionStorage.getItem('geo_status');
    if (sessionStatus === 'block') {
        window.location.href = redirectPath;
        return; // Stop execution here
    }

    // 2. If they are already allowed, let them browse
    if (sessionStatus === 'allow') return;

    console.log(sessionStatus);

    // 3. Only if we have no session data do we call the API
    fetch(`https://api.ipstack.com/check?access_key=${apiKey}`)
        .then(response => response.json())
        .then(data => {
            if (data.country_code && data.country_code !== allowedCountry) {
                // SET THE FLAG FOR BLOCKED USERS
                sessionStorage.setItem('geo_status', 'block');
                window.location.href = redirectPath;
            } else {
                // SET THE FLAG FOR ALLOWED USERS
                sessionStorage.setItem('geo_status', 'allow');
            }
        })
        .catch(error => {
            console.error('Geo-IP lookup failed:', error);
        });
})();